import { useRef as S, useState as g, useCallback as o, useMemo as h } from "react";
import { useControlledState as A, usePreviousValue as E } from "../../../ariakit-react-utils/esm/hooks.js";
function w(a) {
  let {
    animated: n = !1,
    ...l
  } = a === void 0 ? {} : a;
  const O = S(null), [t, e] = A(l.defaultOpen ?? !1, l.open, l.setOpen), [u, c] = g(null), [s, i] = g(!!n && t), v = E(t), r = t || s;
  n && !s && v !== t && i(!0);
  const p = o(() => e(!0), [e]), f = o(() => e(!1), [e]), m = o(() => e((C) => !C), [e]), d = o(() => i(!1), []);
  return h(() => ({
    disclosureRef: O,
    open: t,
    mounted: r,
    animated: n,
    animating: s,
    contentElement: u,
    setContentElement: c,
    setOpen: e,
    show: p,
    hide: f,
    toggle: m,
    stopAnimation: d
  }), [t, r, n, s, u, c, e, p, f, m, d]);
}
export {
  w as useDisclosureState
};
//# sourceMappingURL=disclosure-state.js.map
